import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { VpCheckbox } from '../../inputs';
import { useMediaTableContext } from '../../../hooks';

const headCells = [
  {
    id: 'campaign',
    label: 'Campaign'
  },
  {
    id: 'name',
    label: 'Name'
  },
  {
    id: 'tags',
    label: 'Tags'
  },
  {
    id: 'media',
    label: 'Media'
  },
  {
    id: 'date',
    label: 'Submission Date'
  }
];

export const VpMediaTableHead = () => {
  const { onPageCheck, getIsPageAllSelected, getIsPagePartialSelected } = useMediaTableContext();
  const onClick = () => {
    onPageCheck();
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        <TableCell padding="checkbox">
          <VpCheckbox
            indeterminate={getIsPagePartialSelected()}
            checked={getIsPageAllSelected()}
            onClick={onClick}
          />
        </TableCell>
        {headCells.map((cell) => (
          <TableCell key={cell.id}>{cell.label}</TableCell>
        ))}
        <TableCell padding="checkbox"></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default VpMediaTableHead;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTableHead.jsx